// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  
  config: {
    baseUrlDotNet: '/api',   
    baseUrl: 'http://52.183.34.76:8080/truevoter',
    baseUrl1: 'http://52.183.34.76:8080/truevoter',
    baseUrlSuraj: 'http://192.168.0.121:8080/True_Voter',
    baseUrlSuraj3: 'http://192.168.0.121:8081/True_Voter',
    baseUrlSuraj1: 'http://192.168.0.121:8081/True_Voter',
    baseUrlSuppotView: 'https://api.truevoter.in/True_Voter',
    baseUrlDhananjoy: 'https://api.truevoter.in/True_Voter',
    baseUrlDhananjoy1: 'https://api.truevoter.in/True_VoterNEW',
    baseUrlNomDhananjoy: 'https://api.truevoter.in/Nomination',
    baseUrlShital: 'http://192.168.0.126:8081/True_Voter',
    baseUrlSujit: 'http://192.168.0.35:8080/True_Voter',
    baseUrlSujitNom: 'http://192.168.0.116:8080/Nomination',
    baseUrlSumeet: 'http://localhost:8090/True_Voter',
    baseUrlRatnadeep: 'http://192.168.0.20:8086/True_Voter',
    baseUrlSuraj2: 'http://192.168.0.31:8081/True_Voter',
    baseUrlApk: '/assets/app-debug.apk'
  },

  // ========================================
  // WORLDLINE PAYMENT GATEWAY CONFIGURATION
  // ========================================
  
  /**
   * Worldline Payment Gateway Action URL
   * This is the URL where payment requests are submitted
   * 
   * For TEST/UAT Environment:
   * https://secure.paynimo.com/api/paynimoV2.req
   * 
   * For PRODUCTION Environment:
   * https://secure.paynimo.com/api/paynimoV2.req (same URL, just use production credentials)
   */
  worldlineActionUrl: 'https://secure.paynimo.com/api/paynimoV2.req',
  
  /**
   * Payment Return URL
   * ⚠️ CRITICAL: This URL receives the payment response from Worldline
   * 
   * MUST use hash routing format: /#/payment-response
   * NOT: /payment-response (without hash)
   * 
   * Why? Worldline sends response as POST with form data. Hash routing allows
   * the response to be appended as query parameters which Angular can read.
   * 
   * For Local Development:
   */
  paymentReturnUrl: 'http://localhost:4200/#/payment-response',
  
  /**
   * For Production:
   * paymentReturnUrl: 'https://yourdomain.com/#/payment-response',
   */
  
  /**
   * Payment Notification URL (Server-to-Server callback)
   * This is optional but recommended for production
   * Worldline will POST payment status to this URL on your backend
   */
  paymentNotifyUrl: 'http://localhost:5000/api/payment-callback',
  
  /**
   * For Production:
   * paymentNotifyUrl: 'https://yourdomain.com/api/payment-callback',
   */
  
  /**
   * Backend API URL (your server)
   * Used for server-side operations like hash generation, payment verification
   */
  backendApiUrl: 'http://localhost:5000',
  
  /**
   * For Production:
   * backendApiUrl: 'https://api.yourdomain.com',
   */
  
  /**
   * Worldline Merchant ID
   * This is provided by Worldline when you register
   * 
   * TEST Merchant ID: Use the test credentials provided by Worldline
   * PRODUCTION Merchant ID: Use your live merchant ID
   */
  merchantId: 'L1089929',  // Your merchant ID
  
  /**
   * Hash Generation Service URL
   * This is your existing hash service that generates secure hash for payment
   */
  hashServiceUrl: 'https://sos.alerto.app/web_Services/NeedlyService.svc/GenerateHashFromJson/HashGenerator',
  
  // ========================================
  // ADDITIONAL PAYMENT CONFIGURATION
  // ========================================
  
  /**
   * Payment timeout in milliseconds
   * How long to wait for payment response before timing out
   */
  paymentTimeout: 300000,  // 5 minutes
  
  /**
   * Enable payment debug logs
   * Set to true during development, false in production
   */
  paymentDebug: true,
  
  /**
   * Payment retry configuration
   */
  paymentRetry: {
    maxAttempts: 3,
    delayMs: 1000
  },
  
  /**
   * Currency code
   */
  currency: 'INR',
  
  /**
   * Supported payment modes
   * all - All payment options
   * cards - Only cards
   * netBanking - Only net banking
   * UPI - Only UPI
   */
  paymentModes: 'all'
};

/**
 * ========================================
 * PRODUCTION ENVIRONMENT CONFIGURATION
 * ========================================
 * 
 * Create environment.prod.ts with:
 * 
 * export const environment = {
 *   production: true,
 *   
 *   config: { ... same as above ... },
 *   
 *   // Production URLs
 *   worldlineActionUrl: 'https://secure.paynimo.com/api/paynimoV2.req',
 *   paymentReturnUrl: 'https://yourdomain.com/#/payment-response',
 *   paymentNotifyUrl: 'https://api.yourdomain.com/api/payment-callback',
 *   backendApiUrl: 'https://api.yourdomain.com',
 *   
 *   // Production credentials
 *   merchantId: 'YOUR_PRODUCTION_MERCHANT_ID',
 *   hashServiceUrl: 'https://api.yourdomain.com/generate-hash',
 *   
 *   // Production settings
 *   paymentTimeout: 300000,
 *   paymentDebug: false,  // Disable debug in production
 *   paymentRetry: { maxAttempts: 3, delayMs: 1000 },
 *   currency: 'INR',
 *   paymentModes: 'all'
 * };
 */

/**
 * ========================================
 * IMPORTANT NOTES FOR DEPLOYMENT
 * ========================================
 * 
 * 1. RETURN URL FORMAT:
 *    ✅ CORRECT: https://yourdomain.com/#/payment-response
 *    ❌ WRONG:   https://yourdomain.com/payment-response
 *    The # (hash) is critical for receiving POST data from Worldline
 * 
 * 2. HTTPS REQUIREMENT:
 *    - Production MUST use HTTPS for all URLs
 *    - Payment gateways will not work with HTTP in production
 * 
 * 3. MERCHANT CREDENTIALS:
 *    - Test merchant ID for UAT/testing
 *    - Live merchant ID for production
 *    - Never commit production credentials to version control
 * 
 * 4. CORS CONFIGURATION:
 *    - If using backend API, ensure CORS is configured
 *    - Allow your domain in backend CORS settings
 * 
 * 5. HASH SERVICE:
 *    - Should ideally be on your backend for security
 *    - Never expose merchant key in frontend code
 * 
 * 6. TESTING:
 *    - Always test in UAT environment first
 *    - Use Worldline test cards for testing
 *    - Verify all status codes (success, failure, abort)
 * 
 * 7. ERROR HANDLING:
 *    - Enable debug logs during development
 *    - Disable in production for security
 *    - Set up error monitoring (Sentry, etc.)
 * 
 * 8. SECURITY:
 *    - Always verify payment status on server side
 *    - Don't trust client-side response alone
 *    - Implement checksum verification
 *    - Use server-to-server callback (paymentNotifyUrl)
 */

/**
 * ========================================
 * WORLDLINE STATUS CODES REFERENCE
 * ========================================
 * 
 * 0300 - SUCCESS: Payment completed successfully
 * 0398 - INITIATED: Payment initiated, in progress
 * 0399 - FAILED: Payment failed
 * 0396 - AWAITED: Payment awaiting confirmation
 * 0392 - ABORTED: Payment cancelled by user
 * 
 * Always handle all these status codes in your application
 */


// WEBPACK FOOTER //
// ./src/environments/environment.ts